module.exports = __webpack_public_path__ + "static/media/molluschi.04c6018d.svg";